<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="d-flex align-items-center">
          <div class="m-r-10">
            <span class="btn btn-circle btn-lg bg-danger">
              <i class="ti-clipboard text-white"></i>
            </span>
          </div>
          <div class="pl-3">{{$t("page.content_dashboard.cursos.cursos_presenciales.title")}}</div>
          <div class="ml-auto">
            <div
              v-if="datos.total_cursos_programados_esta_semana == null"
              class="d-flex justify-content-center"
            >
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
            <h2 class="m-b-0 font-light" v-else>
              {{ datos.total_cursos_programados_esta_semana }}
            </h2>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="d-flex align-items-center">
          <div class="m-r-10">
            <span class="btn btn-circle btn-lg btn-info">
              <i class="ti-wallet text-white"></i>
            </span>
          </div>
          <div class="pl-3">{{$t("page.content_dashboard.cursos.acreditaciones_vencer.title")}}</div>
          <div class="ml-auto">
            <div
              v-if="datos.total_cursos_proximos_vencer == null"
              class="d-flex justify-content-center"
            >
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
            <h2 class="m-b-0 font-light" v-else>
              {{ datos.total_cursos_proximos_vencer }}
            </h2>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="d-flex align-items-center">
          <div class="m-r-10">
            <span class="btn btn-circle btn-lg bg-success">
              <i class="fas fa-laptop text-white"></i>
            </span>
          </div>
          <div class="pl-3">{{$t("page.content_dashboard.cursos.cursos_presenciales_mes.title")}}</div>
          <div class="ml-auto">
            <div
              v-if="datos.total_cursos_impartidos_mes == null"
              class="d-flex justify-content-center"
            >
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
            <h2 class="m-b-0 font-light" v-else>
              {{ datos.total_cursos_impartidos_mes }}
            </h2>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      datos: {
        total_cursos_programados_esta_semana: null,
        total_cursos_proximos_vencer: null,
        total_cursos_impartidos_mes: null,
        total_costos_cursos: null,
      },
    };
  },
  methods: {
    Consultar() {
      this.$http
        .get("dashboard/cards")
        .then((respuesta) => {
          return respuesta.json();
        })
        .then((respuestaJson) => {
          this.datos = respuestaJson;
        })
        .catch((error) => {});
    },
  },
  created() {
    this.Consultar();
  },
};
</script>

<style scoped>
.bg-danger {
  background-color: #ff3300 !important;
  color: white;
}
.btn-info {
  background-color: #ff9900 !important;
  color: white;
  border: none;
}
.bg-success {
  background-color: #7b7b7b !important;
  color: white;
}
.bg-warning {
  background-color: #ff9900 !important;
  color: white;
}
.btn-circle{
  cursor: default;
}
</style>



// WEBPACK FOOTER //
// src/components/AppLms/Dashboard/Vistas_Por_Perfil/Administrador.vue